import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, CalendarCheck, Footprints, Truck } from "lucide-react";

export const SOURCES = [
  ["WA", "Chat WA", MessageCircle],
  ["BOOKING", "Kunjungan via Booking", CalendarCheck],
  ["WALKIN", "Datang Langsung (tanpa booking)", Footprints],
  ["KURIR", "Kurir/Ekspedisi", Truck],
];

const waNum = (s) => { let n = String(s || "").replace(/[^\d]/g, ""); if (n.startsWith("0")) n = "62" + n.slice(1); else if (!n.startsWith("62")) n = "62" + n; return n; };

export const ConsignSourceField = ({ form, setForm, bookings }) => {
  const [bq, setBq] = useState("");
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));
  const pickSource = (s) => set({ source: s, source_ref: s === "WA" ? (form.whatsapp || "") : "" });
  const list = useMemo(() => {
    const s = bq.trim().toLowerCase();
    const cp = String(form.whatsapp || "").replace(/[^\d]/g, "").slice(-8);
    const rows = bookings.filter((b) => !s || [b.code, b.name, b.phone, b.date].some((v) => String(v || "").toLowerCase().includes(s)));
    const mine = (b) => (cp && String(b.phone || "").replace(/[^\d]/g, "").endsWith(cp)) || (form.customer_name && b.name === form.customer_name);
    return [...rows].sort((a, b) => (mine(b) - mine(a)) || String(b.date).localeCompare(String(a.date))).slice(0, 50);
  }, [bookings, bq, form.whatsapp, form.customer_name]);
  return (
    <div data-testid="consign-source">
      <div className="grid grid-cols-2 gap-1.5">
        {SOURCES.map(([k, l, Ic]) => (
          <button key={k} type="button" data-testid={`consign-source-${k}`} onClick={() => pickSource(k)}
            className={`flex items-center gap-2 px-2.5 py-2 rounded-lg border text-xs text-left transition-colors ${form.source === k ? "border-sky-500 bg-sky-50 text-sky-800 font-semibold" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>
            <Ic className="w-4 h-4 shrink-0" /> {l}
          </button>
        ))}
      </div>
      {form.source === "WA" && (
        <input data-testid="consign-source-phone" value={form.source_ref} onChange={(e) => set({ source_ref: e.target.value })} placeholder="Nomor telepon WA (mis. 0812…)" className="mt-2 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" />
      )}
      {form.source === "KURIR" && (
        <input data-testid="consign-source-resi" value={form.source_ref} onChange={(e) => set({ source_ref: e.target.value })} placeholder="Ekspedisi / no. resi (opsional)" className="mt-2 w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" />
      )}
      {form.source === "BOOKING" && (
        <div className="mt-2 space-y-1.5">
          <input data-testid="consign-source-booking-search" value={bq} onChange={(e) => setBq(e.target.value)} placeholder="Cari kode / nama / telepon booking…" className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" />
          <select data-testid="consign-source-booking" value={form.source_ref} onChange={(e) => set({ source_ref: e.target.value })} className="w-full border border-slate-300 rounded-lg px-2 py-2 text-sm bg-white">
            <option value="">— Pilih nomor booking —</option>
            {form.source_ref && !list.some((b) => b.code === form.source_ref) && <option value={form.source_ref}>{form.source_ref}</option>}
            {list.map((b) => <option key={b.id} value={b.code}>{b.code} · {b.name} · {b.date} {b.time || ""}</option>)}
          </select>
        </div>
      )}
    </div>
  );
};

export const ConsignSourceTag = ({ c, testid }) => {
  if (!c?.source) return null;
  const s = SOURCES.find(([k]) => k === c.source);
  const Ic = s ? s[2] : MessageCircle;
  const ref = c.source === "BOOKING" && c.source_ref
    ? <Link to={`/app/booking?code=${encodeURIComponent(c.source_ref)}`} className="font-mono text-sky-600 hover:underline" data-testid={`${testid}-booking-link`} onClick={(e) => e.stopPropagation()}>{c.source_ref}</Link>
    : c.source === "WA" && c.source_ref
      ? <a href={`https://wa.me/${waNum(c.source_ref)}`} target="_blank" rel="noreferrer" className="text-emerald-600 hover:underline" data-testid={`${testid}-wa-link`}>{c.source_ref}</a>
      : c.source_ref ? <span>{c.source_ref}</span> : null;
  return (
    <span className="inline-flex items-center gap-1 text-[11px] text-slate-500" data-testid={testid}>
      <Ic className="w-3 h-3" /> {s ? s[1] : c.source}{ref ? <> · {ref}</> : null}
    </span>
  );
};
